import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              凪光系列最新话数与资讯，每周持续更新
            </p>
          </div>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          {latestUpdates.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className={`flex items-start gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors cursor-pointer ${
                index < latestUpdates.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className="hidden sm:flex flex-col items-center min-w-[80px]">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                  {item.updateTime.slice(5).replace('-', '/')}
                </span>
                <span className="text-xs text-foreground-400 mt-0.5">{item.updateTime.slice(0, 4)}年</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="whitespace-nowrap px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-400 sm:hidden">{item.updateTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.description}
                </p>
              </div>
              <div className="hidden sm:flex items-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line text-xl"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}